// Get all elements with class "read-more"
var readMoreElements = document.querySelectorAll(".read-more");

// Loop through each read-more element
readMoreElements.forEach(function(element) {
  // Get the child elements within the read-more element
  var dots = element.querySelector(".dots");
  var moreText = element.querySelector(".more");
  var btnText = element.nextElementSibling; // Assuming the button follows the read-more element

  var readMoreLabel = element.dataset[`readMoreLabel`];
  var readLessLabel = element.dataset[`readLessLabel`];

  // Hide the more text initially
  moreText.style.display = "none";

  // Add click event listener to the button
  btnText.addEventListener("click", function() {
    btnText.classList.toggle("open");
    if (dots.style.display === "none") {
      dots.style.display = "inline";
      btnText.innerHTML = readMoreLabel;
      moreText.style.display = "none";
    } else {
      dots.style.display = "none";
      btnText.innerHTML = readLessLabel;
      moreText.style.display = "inline";
    }
  });
});
